import S3FileUpload from "./ReactS3Lib/ReactS3";
import { S3BucketConfig } from "../common/constants";

export const upload = async (file, newFileName) => {
  try {
    const data = await S3FileUpload.uploadFile(
      file,
      S3BucketConfig,
      newFileName,
    );
    return data.location;
  } catch (err) {
    console.error(err);
    throw err; // Rethrow the error so it propagates to the caller.
  }
};
